/** AUTO-GENERATED from `backend/app/errors/catalog.v1.json`. */
export const ErrorCode = {
  INSUFFICIENT_WALLET_BALANCE: 'insufficient_wallet_balance',
  AUTH_REQUIRED: 'auth_required',
  TOKEN_INVALID: 'token_invalid',
  TOKEN_MISSING: 'token_missing',
  INSUFFICIENT_SCOPE: 'insufficient_scope',
  SUBSCRIPTION_REQUIRED: 'subscription_required',
  NOT_AUTHORIZED: 'not_authorized',
  NOT_FOUND: 'not_found',
  VALIDATION_ERROR: 'validation_error',
  RATE_LIMITED: 'rate_limited',
  SERVICE_UNAVAILABLE: 'service_unavailable',
  INTERNAL_ERROR: 'internal_error',
} as const;

export type ErrorCodeValue = (typeof ErrorCode)[keyof typeof ErrorCode];
